import {ProductHistoryRecord} from "./ProductHistoryRecord";
import {StripeProductName} from "./StripeProductNames";

export class StripeProductHistory {

    private constructor(private products: Map<StripeProductName, ProductHistoryRecord>) {

    }

    public historyFor(name: StripeProductName): ProductHistoryRecord | undefined {
        return this.products.get(name);
    }

    public all(): Array<ProductHistoryRecord> {
        return Array.from(this.products.values());
    }

    public static build(products: Array<ProductHistoryRecord>) {
        const map = new Map<StripeProductName, ProductHistoryRecord>();
        products.forEach((p) => map.set(p.name, p));
        return new StripeProductHistory(map);
    }
}
